import { render, staticRenderFns } from "./SegmentsList.vue?vue&type=template&id=24d4024e&scoped=true&"
import script from "./SegmentsList.vue?vue&type=script&lang=js&"
export * from "./SegmentsList.vue?vue&type=script&lang=js&"
import style0 from "./SegmentsList.vue?vue&type=style&index=0&id=24d4024e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d4024e",
  null
  
)

export default component.exports